import React from 'react';
import { ActionsSVG } from '../../../components/svg';
import { sortCaret, headerSortingClasses } from '../../../helpers';
import { WidgetDate, WidgetStatus, ButtonIcon, WidgetLevelLinkText } from '../../../components';
import statuses from '../../../constants/users/statuses';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ClientsMenuDialog from './ClientsMenuDialog';
import { useTranslation } from 'react-i18next';

export default function ClientsWidgets ({ handleClickMenuClient, handleClickClientDelete, dialog, setDialog }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const dniFormatter = Intl.NumberFormat('es-AR');
    const { t } = useTranslation('translation', { useSuspense: false });
    const openMenu = (event, id) => {
        setAnchorEl(event.target);
        handleClickMenuClient(id);
    };

    return [{
        dataField: 'id',
        text: 'ID',
        sort: false,
        headerSortingClasses,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'formattedName',
        text: t('clients.table.columns.fullname'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'person.document.description',
        text: t('clients.table.columns.document'),
        sort: false,
        formatter: (cellContent, row) => (<WidgetLevelLinkText levelId={row.person.levels.id_level } to={`/clients/details/${row.id}`} text={dniFormatter.format(cellContent) || ''} truncated ='false'/>),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'created_at',
        text: t('clients.table.columns.created') || <><ArrowUpwardIcon style={{ color: '#757575', width: '16px', height: '16px', fontSize: 16 }}/><span style={{ color: '#000000DE', paddingLeft: 10 }}>Alta</span></>,
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetDate date={new Date(cellContent)} />)
    }, {
        dataField: 'person.email.description',
        text: 'Email',
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'person.telephone.description',
        text: t('clients.table.columns.phone'),
        sort: false,
        classes: 'text-uppercase',
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'status.description',
        text: t('clients.table.columns.status'),
        align: 'left',
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => {
            return (
                <>
                    <WidgetStatus type={statuses[cellContent]?.type} text={`clients.table.status.${statuses[cellContent]?.id}`} /></>
            );
        }
    }, {
        dataField: 'person.id',
        text: t('clients.table.columns.actions'),
        width: 108,
        sort: false,
        formatExtraData: {
            openMenu,
            handleClickClientDelete,
            dialog,
            setDialog,
            anchorEl
        },
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row, rowIndex, { openMenu, handleClickClientDelete, dialog, setDialog, anchorEl }) => {
            return (
                <>
                    <ButtonIcon
                        title={t('clients.table.columns.actions')}
                        size='small'
                        icon={(<ActionsSVG />)}
                        onClick={(event) => openMenu(event, row.id)} />
                    {
                        dialog?.type === 'menu' && (
                            <ClientsMenuDialog
                                dialog={dialog}
                                setDialog={setDialog}
                                row={row}
                                onCancel={handleClickClientDelete}
                                anchorEl={anchorEl}
                            />
                        )
                    }
                </>
            );
        }
    }];
}
